export default __webpack_public_path__ + "static/media/020-compass.46aa139c.png";